import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";

const PartRequestStateVisualizer = (partstate) => {

    if (typeof partstate !== 'number' || partstate < 0) {
        throw new Error('Invalid argument for partstate provided: PartRequestStateVisualizer.js line:3');
    };

    const isRequestActive = () => {
        const ACTIVE_STATES = [1, 2];

        let active = false;

        if (ACTIVE_STATES.includes(partstate)) {
            active = true;
        };

        return active;
    };


    const GetActiveStack = () => {
        return (
            <div style={styles.mainContainerActive}>
                <p style={styles.text}>
                    Aktivan
                </p>
            </div>
        );
    };


    const GetUnActiveStack = () => {
        return (
            <div style={styles.mainContainerUnActive}>
                <p style={styles.text}>
                    Neaktivan
                </p>
            </div>
        );
    };


    return isRequestActive()
        ? GetActiveStack()
        : GetUnActiveStack()

};

export default PartRequestStateVisualizer;

const styles = {
    mainContainerActive: {
        display: "flex",
        width: "max-content",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgb(46, 125, 50)",
        borderRadius: 10,
        paddingInline: 8
    },
    text: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "12px",
        color: "#FFFFFF"
    },
    mainContainerUnActive: {
        display: "flex",
        width: "max-content",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "red",
        borderRadius: 10,
        paddingInline: 8
    },
};